
<app-menu-enseignant></app-menu-enseignant>
<router-outlet >

</router-outlet>
